<template>
	<v-btn
		v-bind="$attrs"
		v-on="$listeners"
		rounded
		depressed
		:color="color"
		:class="(color === 'white') ? 'primary--text' : 'white--text'"
	>
		<v-icon v-if="icon" class="mr-2">{{ icon }}</v-icon>
		{{ name }}
	</v-btn>
</template>

<script>
	export default {
		name: "BaseButton",
		props: {
			name: { type: String, default: '' },
			color: { type: String, default: '#258bf5' },
			icon: { type: String }
		}
	}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
</style>